import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './context/AuthContext';
import AppShell from './components/AppShell';
import Login from './pages/Login';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import POS from './pages/POS';
import Tables from './pages/Tables';
import KDS from './pages/KDS';
import Menu from './pages/Menu';
import Orders from './pages/Orders';
import Customers from './pages/Customers';
import FeedbackList from './pages/FeedbackList';
import Inventory from './pages/Inventory';
import Purchasing from './pages/Purchasing';
import Expenses from './pages/Expenses';
import DayClose from './pages/DayClose';
import Backups from './pages/Backups';
import AggregatorInbox from './pages/AggregatorInbox';
import DeliveryImport from './pages/DeliveryImport';
import Reports from './pages/Reports';
import Staff from './pages/Staff';
import Settings from './pages/Settings';
import QROrder from './pages/QROrder';
import Feedback from './pages/Feedback';
import './App.css';

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading RoboChef…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const Shell = ({ children }) => (
  <Protected><AppShell>{children}</AppShell></Protected>
);

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
      <Route path="/qr/:tenantId" element={<QROrder />} />
      <Route path="/qr/:tenantId/:outletId/:tableId" element={<QROrder />} />
      <Route path="/feedback/:tenantId" element={<Feedback />} />
      <Route path="/kds" element={<Protected><KDS /></Protected>} />
      <Route path="/" element={<Shell><Dashboard /></Shell>} />
      <Route path="/pos" element={<Shell><POS /></Shell>} />
      <Route path="/tables" element={<Shell><Tables /></Shell>} />
      <Route path="/menu" element={<Shell><Menu /></Shell>} />
      <Route path="/orders" element={<Shell><Orders /></Shell>} />
      <Route path="/customers" element={<Shell><Customers /></Shell>} />
      <Route path="/feedback-list" element={<Shell><FeedbackList /></Shell>} />
      <Route path="/inventory" element={<Shell><Inventory /></Shell>} />
      <Route path="/purchasing" element={<Shell><Purchasing /></Shell>} />
      <Route path="/expenses" element={<Shell><Expenses /></Shell>} />
      <Route path="/day-close" element={<Shell><DayClose /></Shell>} />
      <Route path="/backups" element={<Shell><Backups /></Shell>} />
      <Route path="/aggregator" element={<Shell><AggregatorInbox /></Shell>} />
      <Route path="/delivery-import" element={<Shell><DeliveryImport /></Shell>} />
      <Route path="/reports" element={<Shell><Reports /></Shell>} />
      <Route path="/staff" element={<Shell><Staff /></Shell>} />
      <Route path="/settings" element={<Shell><Settings /></Shell>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
